import axios from 'axios';
import { BASE_URL } from '../../constantsAPI';

export const instance = axios.create({
    baseURL: BASE_URL,
  });